var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "tooltipAnchor",
      staticClass: "clickable ml-3 convert-icon",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "data-original-title": _vm.$t("client-profile.actions.createActivity"),
      },
      on: { click: _vm.openModal },
    },
    [
      _c("i", {
        staticClass: "fa fa-calendar-plus-o text-primary",
        attrs: { "aria-hidden": "true" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }